const translations = {
  // Login View
  "login.title": "Welcome back",
  "login.roundup.subtitle": "New to ChangeIt?",
  "login.subscription.subtitle": "New to {name}?",
  "login.whitelabel.subtitle": "New to {name}?",
  "login.sign-up.btn.label": "Sign up",
  "login.email.label": "Email",
  "login.password.label": "Password",
  "login.submit.label": "Log in",
  "login.github.label": "Continue with Facebook",
  "login.google.label": "Continue with Google",
  "login.apple.label": "Continue with Apple",
  "login.facebook.label": "Continue with Facebook",
  "login.password-forgot-btn.label": "Forgot my password",
  "login.sso": "OR",
  // Sign Up
  "sign-up.title": "Create your account",
  "sign-up.subtitle": "Already have an account?",
  "sign-up.login.btn": "Log in",
  "sign-up.firstName.placeholder": "First Name",
  "sign-up.lastName.placeholder": "Last Name",
  "sign-up.email.placeholder": "Email",
  "sign-up.email.validation-error": "Email must be a valid email",
  "sign-up.password.placeholder": "Password",
  "sign-up.password.hint": "At least 8 characters, one uppercase, one lowercase, one number and one special character",
  "sign-up.password-confirmation.placeholder": "Confirm password",
  "sign-up.donation.cap.label": "Maximum monthly contribution",
  "sign-up.donation.cap.placeholder": "Unlimited",
  "sign-up.donation.cap.error": "Donation cap must be greater than or equal to 0",
  // TODO make it parametrized
  "sign-up.newsletter.client.label": "I consent to receive updates and communications from {client}",
  "sign-up.newsletter.changeit.label": "I consent to receive updates and communications from ChangeIt",
  "sign-up.over18.msg": "You must agree to be over 18 years old to sign up.",
  "sign-up.over18.label": "I agree that I am aged 18+ and fit to participate in {clientName}.",
  "sign-up.newsletter.roundup.label": "I consent to receive ChangeIt program updates and other communications from {clientName}.",
  "sign-up.newsletter.subscription.label": "I consent to receive program updates and other communications from {clientName}.",
  "sign-up.newsletter.whitelabel.label": "I consent to receive program updates and other communications from {clientName}.",
  "sign-up.submit.label": "Create an account",
  "sign-up.email-btn.label": "Sign up with Email",
  "sign-up.toast.success": "Account successfully created.",
  "sign-up.toc.first": "By registering, you accept our",
  "sign-up.toc.second": "and",
  "sign-up.toc.btn.toc": "Terms of Use",
  "sign-up.toc.btn.privacy": "Privacy Policy",
  "sign-up.github.label": "Sign up with Facebook",
  "sign-up.google.label": "Sign up with Google",
  "sign-up.apple.label": "Sign up with Apple",
  "sign-up.facebook.label": "Sign up with Facebook",
  // Password Reset View
  "password-forgot.title": "Reset password",
  "password-forgot.subtitle": "Enter your email, and you will receive instructions in your inbox to reset your password.",
  "password-forgot.email.label": "Your Email",
  "password-forgot.email.sent": "Verification code sent",
  "password-forgot.submit.label": "Continue",
  "password-forgot.back.label": "Take me back to",
  "password-forgot.back.btn": "login",
  "password-reset-1.title": "Check your inbox",
  "password-reset-1.subtitle-1": "We have sent the verification code to {email}. Please enter the code below.",
  "password-reset-1.token.label": "Verification code",
  "password-reset-1.resend-1": "Didn't receive the email?",
  "password-reset-1.resend-2": "Check your spam filter or",
  "password-reset-1.resend-3": "resend verification code here",
  "password-reset-1.resend-4": "Verification code resent",
  "password-reset-1.expiry": "The verification code will expire in 5 minutes. Please make sure to validate your account within the specified time.",
  "password-reset-2.title": "Reset password",
  "password-reset-2.password.label": "Password",
  "password-reset-2.password-confirmation.label": "Confirm password",
  "password-reset-2.submit.label": "Reset Password",
  // Enroll View
  "enroll.roundup.title": "Welcome to {clientName} ChangeIt program",
  "enroll.subscription.title": "Welcome to {clientName} Team",
  "enroll.whitelabel.title": "Welcome to the {clientName} Program",
  "enroll.roundup.subtitle": "ChangeIt empowers you to effortlessly make a difference while enjoying exclusive discounts and cashback from your favorite brands",
  "enroll.subscription.subtitle": "The {clientName} Membership empowers you to effortlessly make a difference while enjoying exclusive discounts and cashback from your favorite brands",
  "enroll.whitelabel.subtitle": "The {clientName} Program empowers you to effortlessly make a difference while enjoying exclusive discounts and cashback from your favorite brands",
  "enroll.submit.label": "Continue",
  "enroll.newsletter.roundup.label": "I consent to receive ChangeIt program updates and other communications from {clientName}.",
  "enroll.newsletter.subscription.label": "I consent to receive program updates and other communications from {clientName}.",
  "enroll.newsletter.whitelabel.label": "I consent to receive program updates and other communications from {clientName}.",
  // Welcome Modal
  "welcome.roundup.title": "Turn your daily shopping into impactful donations.",
  "welcome.roundup.link-card.title": "Link Your Card: ",
  "welcome.roundup.link-card.text": "Begin rounding up your purchases to the nearest dollar.",
  "welcome.roundup.earn-rewards.title": "Earn Rewards: ",
  "welcome.roundup.earn-rewards.text": "Get cashback and enjoy discounts from hundreds of national and local retailers.",
  "welcome.roundup.make-a-difference.title": "Make a Difference: ",
  "welcome.roundup.make-a-difference.text": "Your rounded-up transactions directly support {clientName}.",
  "welcome.subscription.title": "Become a member today!",
  "welcome.subscription.link-card.title": "Link Your Card: ",
  "welcome.subscription.link-card.text": "Select your membership tier and link your credit card.",
  "welcome.subscription.earn-rewards.title": "Earn Rewards: ",
  "welcome.subscription.earn-rewards.text": "Get access to exclusive Perks & Rewards.",
  "welcome.subscription.make-a-difference.title": "Make a Difference: ",
  "welcome.subscription.make-a-difference.text": "Support our current student-athletes and help us attract the best in the country.",
  "welcome.whitelabel.title": "Turn your daily shopping into impactful donations.",
  "welcome.whitelabel.link-card.title": "Link Your Card: ",
  "welcome.whitelabel.link-card.text": "Begin rounding up your purchases to the nearest dollar.",
  "welcome.whitelabel.earn-rewards.title": "Earn Rewards: ",
  "welcome.whitelabel.earn-rewards.text": "Get cashback and enjoy discounts from hundreds of national and local retailers.",
  "welcome.whitelabel.make-a-difference.title": "Make a Difference: ",
  "welcome.whitelabel.make-a-difference.text": "Your rounded-up transactions directly support {clientName}.",
  // Welcome Reminder Modal
  "welcome.reminder.title": "Unlock a world of benefits",
  "welcome.reminder.subtitle": "Get special perks every time you shop. Plus, with each purchase, you'll also support this important cause. It's a win-win!",
  "welcome.reminder.call-to-action": "Don't miss out. Make every purchase count!",
  // Single Page Signup
  "signup.single-page.tier.title": "Select a plan",
  "signup.single-page.account.title": "Create your account",
  "signup.single-page.account.login.label": "Already have an account?",
  "signup.single-page.account.login.btn": "Log in",
  "signup.single-page.account.sso.label": "Continue with {provider}",
  "signup.single-page.account.sso.email.label": "Continue with email",
  "signup.single-page.account.manual.title": "Account info",
  "signup.single-page.billing.title": "Billing info",
  "signup.single-page.billing.success.first": "Membership activated",
  "signup.single-page.billing.success.second": "Let's finish setting up your profile.",
  "signup.single-page.billing.success.btn": "Continue",
  "signup.single-page.billing.error": "There was an error. Please try again.",
  "signup.single-page.billing.error.first": "We couldn't process your payment",
  "signup.single-page.billing.error.second": "Please review your payment details and try again.",
  "signup.single-page.billing.error.btn": "Try again",
  "signup.single-page.billing.tier.label": "Selected tier",
  "signup.single-page.billing.new.title": "Checkout",
  "signup.single-page.billing.new.plan": "Selected plan",
  "signup.single-page.billing.payment": "Payment details",
  "signup.single-page.billing.destination.title": "You're supporting",
  "signup.single-page.billing.destination.empty": "Choose a school to support",
  "signup.single-page.affinity.title": "Choose the sport you would like to support",
  // Single Page Signup - User Info
  "sign-up.single-page.userinfo.title": "Complete your profile",
  "sign-up.single-page.userinfo.title.kit": "Complete your profile to get your limited edition t-shirt",
  "sign-up.single-page.userinfo.submit": "Submit",
  "sign-up.single-page.userinfo.skip": "I'll do it later",
  "sign-up.single-page.userinfo.firstname": "First Name",
  "sign-up.single-page.userinfo.lastname": "Last Name",
  "sign-up.single-page.userinfo.phone": "Phone",
  "sign-up.single-page.userinfo.street": "Street Address",
  "sign-up.single-page.userinfo.city": "City",
  "sign-up.single-page.userinfo.state.US": "State",
  "sign-up.single-page.userinfo.state.CA": "Province",
  "sign-up.single-page.userinfo.zip.US": "Zip Code",
  "sign-up.single-page.userinfo.zip.CA": "Postal Code",
  "sign-up.single-page.userinfo.country": "Country",
  "sign-up.single-page.userinfo.warning": "Please provide a valid US address",
  "sign-up.single-page.userinfo.mailing_address": "Mailing Address",

  // Membership Migration / Activation
  "activate.title": "Hello {firstName}",
  "activate.roundup.subtitle": "Activate your account to keep supporting {clientName} and enjoy the new benefits of your membership.",
  "activate.whitelabel.subtitle": "Activate your account to keep supporting {clientName} and enjoy the new benefits of your membership.",
  "activate.password": "Please, set a new password and update your payment details to activate your account.",
  "activate.no-charge": "You will not be charged at this time.",
  "activate.charge": "You will be charged",
  "activate.renew": "renewing on {date}.",
  "activate.year": "${amount} per year",
  "activate.month": "${amount} per month",
  "activate.tier": "for the {tier} plan",
  "activate.new-subscription": "You're on the",
  "activate.roundup": "You will be charged based on your monthly round-up contributions",
  "activate.security": "Account Security",
  "activate.password.label": "New Password",
};

export default translations;
